export default __webpack_public_path__ + "static/media/file-search.1d7a8820.svg";